import {organisationsConfigStore} from '@store/settings/organisationsConfig/organisationsConfig.store';
import {getOrganisationsConfigDataSource} from '@store/settings/organisationsConfig/organisationsConfig.requests';
import {select} from '@ngneat/elf';

export class OrganisationsConfigQuery {
  store = organisationsConfigStore;

  organisationsConfig$ = getOrganisationsConfigDataSource.data$();
  pagination$ = this.store.pipe(select(state => state.tablePagination));
  filters$ = this.store.pipe(select(state => state.filters));

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const organisationsConfigQuery = new OrganisationsConfigQuery();
